// Import model
import { CreatePhoneNumberRequest } from '../models/CreatePhoneNumberRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreatePhoneNumberRequest - handles JSON serialization and deserialization with type validation
 */
export class CreatePhoneNumberRequestSerializer {
  /**
   * Deserializes a JSON string into a CreatePhoneNumberRequest instance
   */
  static deserialize(json: string): CreatePhoneNumberRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreatePhoneNumberRequest instance
   */
  static fromObject(obj: any): CreatePhoneNumberRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreatePhoneNumberRequest');
    }


    const instance: CreatePhoneNumberRequest = {
      description: obj['description'] as string,
      phoneNumber: obj['phoneNumber'] as string,
      type_: obj['type'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreatePhoneNumberRequest instances
   */
  static deserializeArray(json: string): CreatePhoneNumberRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreatePhoneNumberRequest instance to a JSON string
   */
  static serialize(instance: CreatePhoneNumberRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreatePhoneNumberRequest instance to a plain object
   */
  static toObject(instance: CreatePhoneNumberRequest): any {
    return {
      'description': instance.description,
      'phoneNumber': instance.phoneNumber,
      'type': instance.type_,
    };
  }

  /**
   * Serializes an array of CreatePhoneNumberRequest instances to a JSON string
   */
  static serializeArray(instances: CreatePhoneNumberRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
